import { ICreateTagEndpoint, ITag } from "./CreateTagEndpoint";
import { IUpdateTag, IUpdateTagEndpoint } from "./UpdateTagEndpoint";

export class TagRepository implements ITagRepository
{
    private createTagEndpoint: ICreateTagEndpoint;
    private updateTagEndpoint: IUpdateTagEndpoint;

    constructor(
        createTagEndpoint: ICreateTagEndpoint,
        updateTagEndpoint:IUpdateTagEndpoint
    )
    {
        this.createTagEndpoint = createTagEndpoint;
        this.updateTagEndpoint = updateTagEndpoint;
    }

    public async createTag(nodeId: number, payload: ITag): Promise<void>
    {
        return this.createTagEndpoint.execute(nodeId, payload);
    }

    public async updateTag(buildingId: number, tagId: string, payload: IUpdateTag): Promise<void>
    {
        return this.updateTagEndpoint.execute(buildingId, tagId, payload);
    }
}

export interface ITagRepository
{
    createTag(nodeId: number, payload: ITag): Promise<void>;
    updateTag(buildingId: number, tagId: string, payload: IUpdateTag): Promise<void>
}